






























































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import * as faceFilter from "facefilter/dist/jeelizFaceFilter.module";
import ProximityTracker, {
  ProximityPhase,
} from "@/utils/headtracker/proximity";
import * as FaceUtils from "@/utils/canvas2ddisplay";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import axios from "axios";

import Loader from "@/components/svg/Loader.vue";
import ErrorSvg from "@/components/svg/Error.vue";

const Theme = namespace("theme");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Capture Selfie",
    };
  },
  components: {
    loader: Loader,
    error: ErrorSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class FallbackSelfie extends Vue {
  @Theme.Getter("getAccentColor") primaryColor;
  @Prop({
    default: "left",
  })
  direction;

  isUploading = false;
  isUploadingError = false;
  isCameraLoading = true;
  hasError = false;
  selfies: string[] = [];
  videoElement?: HTMLVideoElement;
  innerCanvas?: HTMLCanvasElement;
  textStyles = {
    fontSize: "20px Arial",
    color: "rgba(0, 0, 0,0.9)",
    align: "center",
  };

  mounted() {
    let CVD: any = null; // return of Canvas2DDisplay

    const proximityTracker = new ProximityTracker();

    const canvas = this.$refs.canvas as HTMLCanvasElement;
    if (canvas) {
      this.innerCanvas = document.createElement("canvas");
      this.innerCanvas.width = canvas.width;
      this.innerCanvas.height = canvas.height;
    }

    faceFilter.init({
      canvasId: "jeeFaceFilterCanvas",
      NNCpath: "/js/", // root of NNC.json file
      callbackReady: (errCode: any, spec: any) => {
        if (errCode) {
          this.hasError = true;
        }
        this.videoElement = spec.videoElement;
        CVD = FaceUtils.Canvas2DDisplay(spec);

        this.isCameraLoading = false;
      },
      // called at each render iteration (drawing loop):
      callbackTrack: (detectState: any) => {
        const {
          detected: detectedThreshold,
          s: proximityScale,
          x: xCoordinate,
          y: yCoordinate,
        } = detectState;
        if (detectedThreshold > 0.8) {
          // update internal canvas
          if (this.innerCanvas) {
            const innerCtx = this.innerCanvas.getContext("2d");
            if (innerCtx) {
              innerCtx.drawImage(CVD.canvas, 0, 0);
            }
          }

          this.drawOverlay(CVD.canvas, CVD.ctx, proximityTracker);

          // draw a border around the face:
          CVD.update_canvasTexture();

          proximityTracker.update(xCoordinate, yCoordinate, proximityScale);
        }
        CVD.draw();
      },
    });
  }
  drawOverlay(
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D,
    proximityTracker: ProximityTracker
  ): void {
    let faceWidth = 0;
    let faceHeight = 0;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (proximityTracker.phase === ProximityPhase.MoveFurther) {
      faceWidth = 0.25;
      faceHeight = 0.35;
    } else if (proximityTracker.phase === ProximityPhase.MoveCloser) {
      faceWidth = 0.35;
      faceHeight = 0.45;
    }

    if (proximityTracker.shouldFaceBeCentered) {
      ctx.fillStyle = "rgba(200, 200, 200,0.5)";
      ctx.beginPath();
      ctx.rect(0, 0, canvas.width, canvas.height);

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );
      ctx.fill();

      // stroke
      ctx.strokeStyle = "yellow";
      ctx.lineWidth = 4;
      ctx.beginPath();

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );

      ctx.stroke();

      ctx.fillStyle = this.textStyles.color;
    } else {
      if (proximityTracker.phase === ProximityPhase.MoveFurther) {
        ctx.fillStyle = "rgba(200, 200, 200,0.5)";
        ctx.beginPath();
        ctx.rect(0, 0, canvas.width, canvas.height);

        ctx.ellipse(
          canvas.width * 0.5,
          canvas.height * 0.5,
          canvas.width * faceWidth,
          canvas.width * faceHeight,
          0,
          0,
          2 * Math.PI,
          true
        );
        ctx.fill();

        if (proximityTracker.isFaceTooClose) {
          ctx.fillStyle = this.textStyles.color;
          ctx.textAlign = "center";

          ctx.font = "23px Arial";
          ctx.fillText(
            `Move back`,
            canvas.width / 2,
            canvas.height - (canvas.height - 90)
          );

          ctx.font = "20px Arial";
          ctx.fillText(
            `Your face is too close`,
            canvas.width / 2,
            canvas.height - 60
          );
        } else if (proximityTracker.isFaceTooFar) {
          ctx.fillStyle = this.textStyles.color;
          ctx.textAlign = "center";

          ctx.font = "23px Arial";
          ctx.fillText(
            `Move closer`,
            canvas.width / 2,
            canvas.height - (canvas.height - 90)
          );

          ctx.font = "20px Arial";
          ctx.fillText(
            `Your face is too far`,
            canvas.width / 2,
            canvas.height - 60
          );
        } else {
          // stroke
          ctx.strokeStyle = this.primaryColor;
          ctx.lineWidth = 4;
          ctx.beginPath();

          ctx.ellipse(
            canvas.width * 0.5,
            canvas.height * 0.5,
            canvas.width * faceWidth,
            canvas.width * faceHeight,
            0,
            proximityTracker.getProgress(),
            2 * Math.PI,
            true
          );

          ctx.stroke();
          ctx.fillStyle = this.textStyles.color;
          ctx.font = "23px Arial";
          ctx.textAlign = "center";
          ctx.fillText(
            `Hold steady`,
            canvas.width / 2,
            canvas.height - (canvas.height - 90)
          );

          if (proximityTracker.isCompleted) {
            proximityTracker.reset();
            this.captureImageFromVideo();
            proximityTracker.setPhase(ProximityPhase.MoveCloser);
          }
        }
      }
      if (proximityTracker.phase === ProximityPhase.MoveCloser) {
        ctx.fillStyle = "rgba(200, 200, 200,0.5)";
        ctx.beginPath();
        ctx.rect(0, 0, canvas.width, canvas.height);

        ctx.ellipse(
          canvas.width * 0.5,
          canvas.height * 0.5,
          canvas.width * faceWidth,
          canvas.width * faceHeight,
          0,
          0,
          2 * Math.PI,
          true
        );
        ctx.fill();

        if (proximityTracker.isFaceTooClose) {
          ctx.fillStyle = this.textStyles.color;
          ctx.textAlign = "center";

          ctx.font = "23px Arial";
          ctx.fillText(
            `Move back`,
            canvas.width / 2,
            canvas.height - (canvas.height - 90)
          );

          ctx.font = "20px Arial";
          ctx.fillText(
            `Your face is too close`,
            canvas.width / 2,
            canvas.height - 60
          );
        } else if (proximityTracker.isFaceTooFar) {
          ctx.fillStyle = this.textStyles.color;
          ctx.textAlign = "center";

          ctx.font = "23px Arial";
          ctx.fillText(
            `Move closer`,
            canvas.width / 2,
            canvas.height - (canvas.height - 90)
          );

          ctx.font = "20px Arial";
          ctx.fillText(
            `Your face is too far`,
            canvas.width / 2,
            canvas.height - 60
          );
        } else {
          // stroke
          ctx.strokeStyle = this.primaryColor;
          ctx.lineWidth = 4;
          ctx.beginPath();

          ctx.ellipse(
            canvas.width * 0.5,
            canvas.height * 0.5,
            canvas.width * faceWidth,
            canvas.width * faceHeight,
            0,
            proximityTracker.getProgress(),
            2 * Math.PI,
            true
          );

          ctx.stroke();
          ctx.fillStyle = this.textStyles.color;
          ctx.font = "23px Arial";
          ctx.textAlign = "center";
          ctx.fillText(
            `Hold steady`,
            canvas.width / 2,
            canvas.height - (canvas.height - 90)
          );

          if (proximityTracker.isCompleted) {
            proximityTracker.reset();
            this.captureImageFromVideo();
            proximityTracker.setPhase(ProximityPhase.Complete);
          }
        }
      }
    }
  }

  captureImageFromVideo() {
    const video = this.videoElement as HTMLVideoElement;
    const webGLCanvas = this.$refs.canvas as HTMLCanvasElement;
    const canvas = document.createElement("canvas");

    canvas.height = webGLCanvas.height;
    canvas.width = webGLCanvas.width;

    const context = canvas.getContext("2d");
    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
    }
    this.selfies.push(canvas.toDataURL());
    if (this.selfies.length === 2) {
      this.uploadSelfies();
    }
  }

  uploadSelfies() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");

    if (publicKey && applicantId) {
      this.isUploading = true;
      this.isUploadingError = false;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/selfiedata/iosfallback`,
          {
            applicantId,
            publicKey,
            far: this.selfies[0],
            near: this.selfies[1],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          this.isUploading = false;

          const params = new URLSearchParams(window.location.search);
          const publicKey = params.get("publicKey");
          const applicantId = params.get("applicantId");
          const magicLink = params.get("magic");
          const progressionStep = 4;

          const safeQuery = Object.fromEntries(
            Object.entries(this.$route.query).filter(
              ([_, v]) => v !== undefined
            )
          );

          if ((publicKey && applicantId) || magicLink) {
            axios.put(
              `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
              {
                publicKey,
                progressionStep,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
          }

          this.$router.push({ name: "chooseCountry", query: safeQuery });
        })
        .catch((err) => {
          this.isUploading = false;
          this.isUploadingError = true;
          throw err;
        });
    }
  }
  deactivated() {
    console.log("component deactivated");
  }
  async beforeUnmount() {
    await faceFilter.destroy();
    console.log("Camera destroyed");
  }
  unmounted() {
    console.log("Component unmounted");
  }
}
